import { isAcTerminalId } from "./ac";
import { FUSE_TYPES_BY_AIC } from "./fuse-aic";
import type { ComponentDefinition, ComponentNode, FuseType } from "./types";

/** Only a plain two-post DC component can be explicitly given fuse behavior.
 * Names, photos and terminal ampacity never establish installed protection. */
export function canConfigureInlineFuse(def: ComponentDefinition): boolean {
  return def.id === "custom" && def.category === "distribution" &&
    !def.isFuseBlock && !def.acVoltage && !def.renderVariant && !def.simulateStates &&
    !def.internalDcConnections && !def.oneWayDcConnections && !def.currentShunt &&
    def.terminals.length === 2 && def.terminals.every(t =>
      t.polarity === "positive" && !isAcTerminalId(t.id));
}

export function configureInlineFuse(
  node: ComponentNode, rating: number, family: FuseType,
): ComponentNode | null {
  const def = node.customDefinition;
  if (!def || !canConfigureInlineFuse(def) || !Number.isFinite(rating) || rating <= 0 ||
    !FUSE_TYPES_BY_AIC.includes(family)) return null;
  return {
    ...node,
    fuseAmp: rating,
    customDefinition: {
      ...def,
      isFuseBlock: true,
      fuseSlotType: family,
      equipmentLimitExemption: "fuse",
      // A fuse is bidirectional; this conventional input/output split lets
      // the existing holder model recognize the series link in either wiring order.
      terminals: def.terminals.map((t, index) => ({ ...t, direction: index === 0 ? "input" : "output" })),
    },
  };
}
